// Превключвателят между трите изгледа на „Сторно".
//
// Същата релса като чиповете за период: сегментиран контрол, а не табове с
// подчертаване — на POS терминал се уцелва по-лесно.

export type CancellationsView = "list" | "waiter" | "product";

type Props = {
  value: CancellationsView;
  onChange: (view: CancellationsView) => void;
  labels: Record<CancellationsView, string>;
};

const VIEWS: CancellationsView[] = ["list", "waiter", "product"];

export const CancellationsTabs = ({ value, onChange, labels }: Props) => (
  <div
    role="tablist"
    className="flex shrink-0 items-center gap-1 self-start rounded-[10px] bg-fill-2 p-[3px]"
  >
    {VIEWS.map((view) => (
      <button
        key={view}
        type="button"
        role="tab"
        aria-selected={value === view}
        onClick={() => onChange(view)}
        className={`h-[30px] whitespace-nowrap rounded-[7px] px-3 text-[12px] font-bold transition-colors ${
          value === view
            ? "bg-surface text-ink shadow-sm"
            : "text-soft hover:text-ink"
        }`}
      >
        {labels[view]}
      </button>
    ))}
  </div>
);
